module.exports = __webpack_public_path__ + "img/logo.e2b8d623.png";